var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddUserRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.56,
    height: 12.56
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001847",
    d: "M11.238 4.958H7.6V1.322a1.322 1.322 0 00-2.644 0v3.636H1.32a1.322 1.322 0 000 2.644h3.636v3.636a1.322 1.322 0 002.644 0V7.6h3.636a1.322 1.322 0 000-2.644z"
  })));
}

export default SvgAddUserRounded;